
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"128","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M512 992A480.512 480.512 0 0132 512 480.512 480.512 0 01512 32a480.512 480.512 0 01480 480 480.512 480.512 0 01-480 480zm0-434.624l135.68 135.68a32 32 0 0022.72 9.344 32 32 0 0022.528-9.344 32 32 0 009.344-22.592 32 32 0 00-9.344-22.656L557.184 511.936l135.744-135.68a32 32 0 009.472-22.784 31.488 31.488 0 00-9.472-22.464 31.552 31.552 0 00-22.656-9.472 31.552 31.552 0 00-22.656 9.472L511.936 466.88 376.064 331.008a31.552 31.552 0 00-22.656-9.472 31.488 31.488 0 00-22.592 9.472 32 32 0 000 45.248l135.872 135.68-135.872 135.872a31.168 31.168 0 00-9.344 22.464 31.616 31.616 0 009.344 22.72 32 32 0 0022.656 9.344A32 32 0 00376 692.992l135.872-135.68z","fill":"currentColor"}})])
          )
        }
      }
    